import { AuthUserPermission, FieldModel } from '@cibo/core'
import {
  AddFieldsButtonProps,
  LandManagerToolbar,
  PaginatedFieldsContext,
  PaginatedFieldsTableProps,
  SelectablePaginatedFieldsTable,
} from '@cibo/landmanager'
import { useAuth, usePermissions } from '@cibo/profile'
import { Stack } from '@mui/material'
import { GRID_CHECKBOX_SELECTION_COL_DEF, GridRowParams } from '@mui/x-data-grid-pro'
import { useContext } from 'react'
import { FieldTableHeader } from './FieldTableHeader'
import { FieldTablePanelContent } from './FieldTablePanelContent'

interface FieldTableProps
  extends Pick<
      PaginatedFieldsTableProps,
      'baseQuery' | 'components' | 'columns' | 'onCellClick' | 'hideBorders' | 'hideCellFocus'
    >,
    Pick<AddFieldsButtonProps, 'paths'> {
  title?: string
}

export const FieldTable = ({
  baseQuery,
  columns,
  components: { Toolbar, ...otherComponents } = {},
  paths,
  title,
  ...dataGridProps
}: FieldTableProps) => {
  const { persona } = useAuth()
  const { can } = usePermissions()
  const { filters } = useContext(PaginatedFieldsContext)

  return (
    <SelectablePaginatedFieldsTable
      key={JSON.stringify(filters)}
      baseQuery={
        !!baseQuery
          ? {
              ...baseQuery,
              includeAllDetails: true,
            }
          : {
              includeAllDetails: true,
            }
      }
      columns={columns}
      pinnedColumns={{
        left: [GRID_CHECKBOX_SELECTION_COL_DEF.field, 'actions'],
      }}
      components={{
        Toolbar: () => (
          <Stack spacing={1} sx={{ pt: 1, width: '100%' }}>
            <FieldTableHeader AddFieldsButtonProps={{ paths: paths }} title={title} />
            {Toolbar && <Toolbar />}
          </Stack>
        ),
        BulkActions: props => <LandManagerToolbar {...props} />,
        ...otherComponents,
      }}
      initialSort={[{ field: 'updatedAt', sort: 'desc' }]}
      //@ts-ignore
      isRowSelectable={
        ({ row }: GridRowParams<FieldModel>) => true /*deprecated: !row.isEnrolledInAnyProgram()*/
      }
      getDetailPanelHeight={() => 'auto'}
      getDetailPanelContent={
        persona !== 'grower' || can({ useAny: AuthUserPermission.DEBUG_USER })
          ? ({ row }: { row: FieldModel }) => <FieldTablePanelContent field={row} />
          : undefined
      }
      disableColumnMenu={true}
      getRowClassName={() => 'row'}
      getRowHeight={() => 'auto'}
      sx={{
        borderStyle: 'none',
        '.row div.fullCell': {
          padding: 0,
        },
      }}
      {...dataGridProps}
    />
  )
}
